import { Box, Collapse, IconButton, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

export type FinancialStatusCollapseProps = {
    children: React.ReactNode;
    isOpen: boolean;
    onClick: () => void;
};

export function FinancialSectionCollapse({ onClick, children, isOpen }: FinancialStatusCollapseProps) {
    const translate = getSelectedLanguage();

    return (
        <>
            <Box
                alignItems="center"
                display="flex"
                onClick={onClick}
                sx={{ cursor: 'pointer' }}
            >
                <IconButton
                    icon={isOpen ? 'caret-up' : 'caret-down'}
                    size="small"
                    sx={{ marginLeft: '-10px' }}
                />
                <Text
                    color="minimal"
                    fontWeight="bold"
                    size="xs"
                    sx={{ '&:hover': { borderBottom: 'none' }, borderBottom: '1px solid', marginBottom: '1px' }}
                >
                    {translate.processDetails.financialStatus}
                </Text>
            </Box>
            <Collapse isOpen={isOpen}>{children}</Collapse>
        </>
    );
}
